import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/account/[address]/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/opt/build/repo/components/CopyButton.tsx");
